import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Close: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M22 2L2 22M2 2L22 22'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default Close
